import { FC, HTMLAttributes } from 'react';

type FordefiWalletProps = HTMLAttributes<SVGElement> & {
  size?: number;
};

const FordefiWallet: FC<FordefiWalletProps> = ({ size = 16, ...props }) => {
  const ratio = 32.696 / 28;
  const width = size * ratio;
  return (
    <svg
      height={size}
      width={width}
      viewBox="0 0 32.696 28"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M 14.333 19.708 L 0 19.708 L 0 23.245 C 0 25.744 2.032 27.77 4.538 27.77 L 10.318 27.77 L 14.333 19.708 Z"
        fill="#7994FF"
      ></path>
      <path
        d="M 0 10.302 L 27.323 10.302 L 24.151 17.02 L 0 17.02 L 0 10.302 Z"
        fill="#486DFF"
      ></path>
      <path
        d="M 9.582 0 L 0 0 L 0 7.614 L 32.698 7.615 L 32.698 0 L 23.116 0 L 23.116 5.687 L 21.139 5.687 L 21.139 0 L 11.558 0 L 11.558 5.687 L 9.582 5.687 L 9.582 0 Z"
        fill="#5CD1FA"
      ></path>
    </svg>
  );
};

export default FordefiWallet;
